import * as React from 'react';
import { Container } from 'reactstrap';
import { connect } from 'react-redux';
import loginLogo from '../../../images/GMCNgine.png';
import ff from '../../../images/partners/ff.svg';
import ffh from '../../../images/partners-hover/ff.png';
import fia from "../../../images/partners/fia.svg";
import fiah from "../../../images/partners-hover/fia.png";
import aws from "../../../images/partners/aws.svg";
import awsh from "../../../images/partners-hover/aws.png";
import webiq from "../../../images/partners/webiq.png";
import webiqh from "../../../images/partners-hover/webiq.png";
import biometrica from "../../../images/partners/biometrica.png";
import biometricah from "../../../images/partners-hover/biometrica.png";
import { Login } from '../Login/Login';
import { IAuthState } from '../store/types';
import { IReduxState } from 'src/reduxTypes';
import './container.css';

interface IPartnerProps {
    src: string;
    hover: string;
    className: string;
}

const Partner: React.SFC<IPartnerProps> = (props) => {
    return <img className={`partners ${props.className}`} src={props.src} onMouseOver={e => e.currentTarget.src = props.hover} onMouseOut={e => e.currentTarget.src = props.src} />;
};

export interface IAuthContainerProps {
    match: any;
    auth: IAuthState;
    history: any;
    location: any;
}

export class AuthContainer extends React.Component<IAuthContainerProps> {
    public render(): React.ReactElement {
        return (
            <Container className="login">
                <div className="login-bg white-background">
                    <img src={loginLogo} alt="GMCNgine" className="login-logo" />
                    <Login {...this.props} />
                </div>
                <div className="partners-container">
                    <h3 className="partners-text">Our Technology Partners</h3>
                    <div className="partners">
                        <Partner className="ff" src={ff} hover={ffh} />
                        <Partner className="fia" src={fia} hover={fiah} />
                        <Partner className="aws" src={aws} hover={awsh} />
                        <Partner className="webiq" src={webiq} hover={webiqh} />
                        <Partner className="biometrica" src={biometrica} hover={biometricah} />
                    </div>
                </div>
            </Container>
        );
    }
}

const mapStateToProps = (state: IReduxState) => {
    return {
        auth: state.auth,
    }
}

export default connect(mapStateToProps)(AuthContainer);
